module.exports = __webpack_public_path__ + "img/sms-3-2.e69e2329.png";